import { render, staticRenderFns } from "./Opz2Empty.vue?vue&type=template&id=29017b57&scoped=true"
import script from "./Opz2Empty.vue?vue&type=script&lang=ts"
export * from "./Opz2Empty.vue?vue&type=script&lang=ts"
import style0 from "./Opz2Empty.vue?vue&type=style&index=0&id=29017b57&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29017b57",
  null
  
)

export default component.exports